export const SESSION_ID = 'sessionId';
export const LAST_ACTION = 'lastAction';
export const CURRENT_USER_LAST_ACTIVE_ROLE = 'currentUserLastActiveRole';
